import { gql } from "@apollo/client";
import DropdownInput from "components/common/form/inputs/dropdown/DropdownInput";
import { graph } from "config/axios-context";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { IdName } from "types/common-types";
import { DropdownInputPropsType } from "types/form-types";
import { FruitFilterInput, FruitSortInput, GetFruitsAllQuery } from "types/graphql";
import * as lodash from 'lodash';

const fruitListQuery = gql`
query getFruitsAll {
    fruits {
        items {
            id,
            name
        }
    }
}
`

type FruitInputPropsType = Partial<DropdownInputPropsType<IdName, FruitFilterInput, FruitSortInput>>

const FruitInput = (props: FruitInputPropsType) => {
    const [fruits, setFruits] = useState<IdName[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if(!props.dataSource) {
            loadData().then();
        }
    }, []);

    const loadData = async () => {
        setLoading(true);
        const response = await graph<GetFruitsAllQuery>({
            query: fruitListQuery
        });

        if(response.errors) {
            throw response.errors;
        }

        setFruits(response.data!.fruits!.items!.map(i => {
            return {
                id: i!.id,
                name: i!.name
            }
        }));

        setLoading(false);
    }

    const fruitDropdownSettings: DropdownInputPropsType<IdName> = {
        dataSource: {
            data: (search) => {
                if(loading) {
                    return [{
                        name: t('common.loading'),
                        id: -1
                    }]
                }

                if(search) {
                    return fruits.filter(f => f.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
                }

                return fruits;
            },
            search: 'switch'
        },
        getItemId: i => i.id,
        view: {
            inputView: i => i?.name
        },
        label: 'fields.fruit.name',
        name: "fruit"
    }

    const settings = lodash.merge(fruitDropdownSettings, props);

    return (
            <DropdownInput
                {...settings}
                value={props.value}
            />
    );
};

export default FruitInput;
